import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=41e1f6a9&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=41e1f6a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1f6a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e1f6a9')) {
      api.createRecord('41e1f6a9', component.options)
    } else {
      api.reload('41e1f6a9', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=41e1f6a9&scoped=true&", function () {
      api.rerender('41e1f6a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4Utkz1jytcoXE/JS/comp/DocBox.vue"
export default component.exports